module.exports = __webpack_public_path__ + "static/media/aspas.0390db53.svg";